module.exports = __webpack_public_path__ + "static/media/need-connectrx.76a75f47.jpg";